import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { Lightbox } from "ngx-lightbox/lightbox.service";
import { c1, c10, c3, c4, c5, c6, offcanvasColors } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-gen-isideinfo-component",
  templateUrl: "./gen-isideinfo-component.component.html",
  styleUrls: ["./gen-isideinfo-component.component.scss"],
})
export class GenISideInfoComponentComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    private modalService: BsModalService,
    private builderService: BuilderService,
    private lightbox: Lightbox,

  ) { }

  @Input() page_id: string;
  @Input() tabData: Tab;

  page: any;

  c6_value: string;
  c3_value: string;
  offCanvasSubscription: any;
  albums = [];
  title: string;
  offcanvasColors = offcanvasColors;
  enableNav: boolean;
  singleTab : string = c3.SINGLE;

  ngOnInit() {
    this.albums = [
      { id: c6.TOP, src: '../../../assets/images/small/img-1-anavtab.jpg', caption: " Drawer @ App bar" },
      { id: c6.BOTTOM,src: '../../../assets/images/small/img-2-anavtab.jpg', caption: "Drawer @ Nav bar" }
    ]
      this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        if (
          data &&
          data.off_canvas_key === "gen" &&
          data.page.id == this.page_id
        ) {

          // c6: ios home - side menu top, bottom
          this.c6_value = localStorage.getItem("mode")[5]
          this.c3_value = localStorage.getItem("mode")[2]
        }
      }
    );

  }
  open(index: number): void {
    // open lightbox
    this.c6_value = this.albums[index].id;
    let modes = [{ id: c6.ID, value: this.c6_value },];
    this.mdw.changeMobileTheme(modes)
    this.mdw.changeTab({tab:this.tabData}, localStorage.getItem("mode"), true)
  }

  ngOnDestroy(): void {
    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }
  }
}
